<template>
  <div>
    <div class="helpCenter_search">
      <div class="helpCenter_search_box">
        <div class="helpCenter_search_left" v-if="ispc">
          <div class="helpCenter_search_left_top" >
            <input class="helpCenter_search_left_top_input" placeholder="Search" @input="searchArticle(searchText, 1)" v-model="searchText" @keydown.enter="searchArticle(searchText, 2)" @focus="searchShow(1)" @blur="searchShow(2)" />
            <div v-if="searchListShow" class="search_data">
              <div class="search_data_list" v-for="(item, index) in input_data" :key="index" @click="() => {searchText = item.post_title;changeRoute(item, 4)}">{{ item.post_title }}</div>
              <div v-if="input_data.length === 0" class="search_data_list">No results found</div>
            </div>
            <img src="../assets/helpCenter_search.svg" alt="" @click="searchArticle(searchText, 2)"/>
          </div>
          <div v-if="categoryFlag == true" class="helpCenter_search_left_category">
            <div class="helpCenter_search_left_category_title">
              Category
            </div>
            <div class="helpCenter_search_left_category_list">
              <ul>
                <li @click.stop="firstNodeClick(0)" class="helpCenter_search_left_category_ul">
                  <div class="helpCenter_search_left_category_ul_div">
                  <img :src="firstNode == 0 ? require('../assets/help_bottom.svg') : require('../assets/help_right.svg')" alt="">Directions
                  </div>
                  <ul :class="firstNode == 0 ? 'helpCenter_search_left_category_first' : 'helpCenter_search_left_category_first helpCenter_search_left_category_first_hide'">
                    <li v-for="(item,index) in directions_data" :key="index" class="helpCenter_search_left_category_li_second" @click.stop="getDirectionsArticleByName(index,item.name, item)">
                      <div :class="secondNode == index && articleId[2]== 0 &&articleNumber == 1? 'helpCenter_search_left_category_choose' : 'helpCenter_search_left_category_nochoose'">
                        <div v-if="articleId[1] == secondNode && articleId[1] == index">
                          <img :src="(secondNode == index && articleNumber != 1) ? require('../assets/help_bottom.svg') : require('../assets/help_right_green.svg')" alt="">
                          <span>{{item.name}}</span>
                        </div>
                        <div v-else>
                          <img :src="(secondNode == index && articleNumber != 1) ? require('../assets/help_bottom.svg') : require('../assets/help_right.svg')" alt="">
                          <span>{{item.name}}</span>
                        </div>
                      </div>
                      <ul :class="secondNode == index 
                        ? 'helpCenter_search_left_category_second' 
                        : 'helpCenter_search_left_category_second helpCenter_search_left_category_second_hide'">
                        <div v-for="(value,count) in item.data" :key="count" @click.stop="changeArticleByName(index,count,value)">
                          <li v-if="articleNumber != 1"
                            :class="thirdNode == count 
                            ? 'helpCenter_search_left_category_forth helpCenter_search_left_category_forth_choose' 
                            : 'helpCenter_search_left_category_forth'">
                            <div>{{value.post_title}}</div>
                          </li>
                        </div>
                      </ul>
                    </li>
                  </ul>
                </li>
                <li @click.stop="firstNodeClick(1)" class="helpCenter_search_left_category_ul">
                  <div class="helpCenter_search_left_category_ul_div"><img :src="firstNode == 1 ? require('../assets/help_bottom.svg') : require('../assets/help_right.svg')" alt="">Apps</div>
                  <ul :class="firstNode == 1 ? 'helpCenter_search_left_category_first' : 'helpCenter_search_left_category_first helpCenter_search_left_category_first_hide'">
                    <li v-for="(item,index) in category_data" :key="index" @click.stop="secondNodeClick(index)" class="helpCenter_search_left_category_li">
                      <div class="helpCenter_search_left_category_li_div"><img :src="secondNode == index ? require('../assets/help_bottom.svg') : require('../assets/help_right.svg')" alt=""><span>{{item.name}}</span></div>
                      <ul :class="secondNode == index 
                        ? 'helpCenter_search_left_category_second' 
                        : 'helpCenter_search_left_category_second helpCenter_search_left_category_second_hide'">
                        <li v-for="(value,count) in item.data" :key="count"  @click.stop="getArticleByName(index,value.app_name,count, value)" 
                        class="helpCenter_search_left_category_li_second">
                        <div :class="thirdNode == count && articleId[3]== 0? 'helpCenter_search_left_category_choose' : 'helpCenter_search_left_category_nochoose'">
                          <div v-if="articleId[2] == count && articleId[2] == thirdNode &&articleId[3] == 0">
                            <img :src="(thirdNode == count && articleNumber != 1) ? require('../assets/help_bottom_green.svg') : require('../assets/help_right_green.svg')" alt="">
                            <span>{{value.app_name}}</span>
                          </div>
                          <div v-else>
                            <img :src="(thirdNode == count && articleNumber != 1) ? require('../assets/help_bottom.svg') : require('../assets/help_right.svg')" alt="">
                            <span>{{value.app_name}}</span>
                          </div>
                        </div>
                          <ul :class="thirdNode == count
                          ? 'helpCenter_search_left_category_third' 
                          : 'helpCenter_search_left_category_third helpCenter_search_left_category_third_hide'">
                            <div v-for="(data,number) in value.post" :key="number" 
                              @click.stop="changeArticle(index,count,number,data)">
                              <li v-if="number != 0"
                              :class="forthNode == number 
                              ? 'helpCenter_search_left_category_forth helpCenter_search_left_category_forth_choose'  
                              : 'helpCenter_search_left_category_forth'" 
                              >
                                <div>{{data.post_title}}</div>
                              </li>
                            </div>
                          </ul>
                        </li>
                      </ul>
                    </li>
                  </ul>
                </li>
              </ul>
            </div>
          </div>
        </div>
        
        <div class="helpCenter_search_right">
          <div class="helpCenter_search_right_article">
            <div v-if="categoryFlag == false">
              <div class="helpCenter_search_right_article_top">
                <div class="helpCenter_search_right_article_title">
                  Search results for
                  <span> {{ searchContent }}</span>
                  <div v-if="article_data.length === 0" class="helpCenter_search_right_article_notfound">
                    No articles were found, try again or consult our team?
                  </div>
                </div>
                <div v-if="article_data.length !== 0" class="helpCenter_search_right_article_count">
                  <span>{{ article_data.length }}</span> articles found
                </div>
              </div>
              <div class="helpCenter_search_right_article_content">
                <div
                  v-for="(item, index) in article_data"
                  :key="index"
                  class="helpCenter_search_right_article_content_box"
                >
                  <div class="helpCenter_search_right_article_content_title" @click="changeRoute(item, 4)" v-html="item.post_title">
                  </div>
                  <div class="helpCenter_search_right_article_content_content" @click="changeRoute(item, 4)" v-html="item.post_content">
                  </div>
                </div>
              </div>
            </div>
            <div v-else-if="popularFlag === true">
              <div class="helpCenter_search_right_article_top">
                <div class="helpCenter_search_right_article_title">
                  Most Popular Articles
                </div>
              </div>
              <div class="helpCenter_search_right_article_content">
                <div
                  v-for="(item, index) in mostPopular_data"
                  :key="index"
                  class="helpCenter_popular_right_article_content_box"
                >
                  <div class="helpCenter_search_right_article_content_content_most" @click="changeRoute(item, 1)">
                    {{ item.name }}
                  </div>
                </div>
              </div>
            </div>
            <div v-else>
              <div
                class="helpCenter_search_right_article_html wordPressClass"
              >
                <div class="helpCenter_search_right_article_html_title">{{articleName}}</div>
                <div class="helpCenter_search_right_article_html_content" v-html="articleContent"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    
    <div v-if="categoryFlag == true&&ispc==false" class="helpCenter_search_left_category">
      <div class="helpCenter_search_left_category_title" @click="showtitle(0)">
        Category
        <img src="../assets/up.svg" alt="" v-if="showCategory">
        <img src="../assets/down.svg" alt="" v-else>
      </div>
      <div class="helpCenter_search_left_category_list" v-if="showCategory">
        <ul>
          <li @click.stop="firstNodeClick(0)" class="helpCenter_search_left_category_ul">
            <div class="helpCenter_search_left_category_ul_div">
            <img :src="firstNode == 0 ? require('../assets/help_bottom.svg') : require('../assets/help_right.svg')" alt="">Directions
            </div>
          </li>
          <ul :class="firstNode == 0 ? 'helpCenter_search_left_category_first' : 'helpCenter_search_left_category_first helpCenter_search_left_category_first_hide'">
            <li v-for="(item,index) in directions_data" :key="index" class="helpCenter_search_left_category_li" @click.stop="getDirectionsArticleByName(index,item.name, item)">
              <div class='helpCenter_search_left_category_nochoose'>
                <div v-if="articleId[1] == secondNode && articleId[1] == index" 
                :class="secondNode == index && articleId[2]== 0 &&articleNumber == 1?'helpCenter_display helpCenter_display2':'helpCenter_display'">
                  <img :src="(secondNode == index && articleNumber != 1) ? require('../assets/help_bottom.svg') : require('../assets/help_right_green.svg')" alt="">
                  <span>{{item.name}}</span>
                </div>
                <div class="helpCenter_display" v-else>
                  <img :src="(secondNode == index && articleNumber != 1) ? require('../assets/help_bottom.svg') : require('../assets/help_right.svg')" alt="">
                  <span>{{item.name}}</span>
                </div>
              </div>
              <ul :class="secondNode == index 
                ? 'helpCenter_search_left_category_second' 
                : 'helpCenter_search_left_category_second helpCenter_search_left_category_second_hide'">
                <div v-for="(value,count) in item.data" :key="count" @click.stop="changeArticleByName(index,count,value)">
                  <li v-if="articleNumber != 1"
                    :class="thirdNode == count 
                    ? 'helpCenter_search_left_category_forth helpCenter_search_left_category_forth_choose' 
                    : 'helpCenter_search_left_category_forth'">
                    <div>{{value.post_title}}</div>
                  </li>
                </div>
              </ul>
            </li>
          </ul>
          <li @click.stop="firstNodeClick(1)" class="helpCenter_search_left_category_ul">
            <div class="helpCenter_search_left_category_ul_div"><img :src="firstNode == 1 ? require('../assets/help_bottom.svg') : require('../assets/help_right.svg')" alt="">Apps</div>         
          </li>
          <ul :class="firstNode == 1 ? 'helpCenter_search_left_category_first' : 'helpCenter_search_left_category_first helpCenter_search_left_category_first_hide'">
            <li v-for="(item,index) in category_data" :key="index" @click.stop="secondNodeClick(index)" class="helpCenter_search_left_category_li">
              <div class="helpCenter_search_left_category_li_div"><img :src="secondNode == index ? require('../assets/help_bottom.svg') : require('../assets/help_right.svg')" alt=""><span>{{item.name}}</span></div>
              <ul :class="secondNode == index 
                ? 'helpCenter_search_left_category_second' 
                : 'helpCenter_search_left_category_second helpCenter_search_left_category_second_hide'">
                <li v-for="(value,count) in item.data" :key="count"  @click.stop="getArticleByName(index,value.app_name,count, value)" 
                class="helpCenter_search_left_category_li_second">
                <div class="helpCenter_search_left_category_nochoose">
                  <div v-if="articleId[2] == count && articleId[2] == thirdNode &&articleId[3] == 0" class="helpCenter_display helpCenter_display2">
                    <img :src="(thirdNode == count && articleNumber != 1) ? require('../assets/help_bottom_green.svg') : require('../assets/help_right_green.svg')" alt="">
                    <span>{{value.app_name}}</span>
                  </div>
                  <div class="helpCenter_display" v-else>
                    <img :src="(thirdNode == count && articleNumber != 1) ? require('../assets/help_bottom.svg') : require('../assets/help_right.svg')" alt="">
                    <span>{{value.app_name}}</span>
                  </div>
                </div>
                  <ul :class="thirdNode == count
                  ? 'helpCenter_search_left_category_third' 
                  : 'helpCenter_search_left_category_third helpCenter_search_left_category_third_hide'">
                    <div v-for="(data,number) in value.post" :key="number" 
                      @click.stop="changeArticle(index,count,number,data)">
                      <li v-if="number != 0"
                      :class="forthNode == number 
                      ? 'helpCenter_search_left_category_forth helpCenter_search_left_category_forth_choose'  
                      : 'helpCenter_search_left_category_forth'" 
                      >
                        <div>{{data.post_title}}</div>
                      </li>
                    </div>
                  </ul>
                </li>
              </ul>
            </li>
          </ul>
        </ul>
      </div>
    </div>
    <div class="cover" v-if="showCategory"></div>
    <Footer></Footer>
  </div>
</template>

<script>
import Header from "./common/header.vue";
import Footer from "./common/footer.vue";
import Top from "./common/top.vue";
import Skeleton from "./common/skeleton.vue";
// import "./style/wordpress.less";

export default {
  name: "Detail",
  components: {
    Header,
    Footer,
    Top,
    Skeleton,
  },
  data() {
    return {
      input_data: [],
      popular_search: [],
      tab: ["All apps"],
      allapp_data: [],
      article_data: [],
      mostPopular_data: [],
      tabid: 0,
      searchFlag: false,
      searchContent: "",
      popularFlag: false,
      categoryFlag: false,
      searchText: "",
      searchListShow: false,
      searchTermStr: "",
      searchIdStr: "",
      countPageContent: {},
      searchBetweenTimer: null,
      hotArticle: [],
      firstNode: -1,
      secondNode: -1,
      thirdNode: -1,
      forthNode: -1,
      articleId: [-1, -1, -1, -1],
      articleContent: "",
      articleName: "",
      articleNumber: -1,
      pageId: "",
      category_data: [],
      directions_data: [
        {
          name: "Get started",
          data: "",
        },
        {
          name: "Pricing & Plans",
          data: "",
        },
        {
          name: "Miscellaneous",
          data: "",
        },
        {
          name: "General",
          data: "",
        },
      ],
      ispc:true,
      showCategory:false
    };
  },
  deactivated() {
    this.$destroy();
  },
  methods: {
    getData() {
      this.$axios.get(`https://gateway.salesdish.com/shopify-service/app-tools/pass/apps/1100`).then((res)=>{
        // console.log(res.data);
        for(let i = 1; i < res.data.list.length; i++){
          if(res.data.list[i].enabled == true){
            var obj ={
              name:'',
              data:[]
            }
            obj.name=res.data.list[i].name
            this.tab.push(res.data.list[i].name)
            res.data.list[i].children.forEach(value=>{
              var item = new Object
              item.app_name = value.name
              this.searchTermStr = this.searchTermStr + value.name  + ','
              item.app_content = value.introduce
              if(value.enabled == true || value.id === 36427){
                try {
                  item.img = require(`../assets/antools_app_icon${value.id}.svg`)
                  obj.data.push(item)
                  this.allapp_data.push(item)
                } catch (error) {
                  // console.log("Image lost:" +value.name);
                  // console.log("ID:" + value.id);
                  item.img = require(`../assets/antools_app_icon_default.svg`)
                  obj.data.push(item)
                  this.allapp_data.push(item)
                }
              }
            })
            this.category_data.push(obj)
          }
        }
        this.routerChange();
      });
    },
    showtitle(index){
      window.event? window.event.cancelBubble = true : e.stopPropagation();
      if(index==0){
        this.showCategory=!this.showCategory
      }
    },
    close(){
      console.log(123)
      this.showCategory=false
    },
    // 展示搜索下拉框列表
    searchShow(type) {
      if (type === 1) {
        if (this.input_data.length > 0) {
          this.searchListShow = true;
        } else {
          this.searchListShow = false;
        }
      } else if (type === 2) {
        setTimeout(() => {
          this.searchListShow = false;
          this.input_data = [];
        }, 300);
      }
    },
    // 文章计数
    getAndSaveCount(name, data) {
      // 接口获取计数文章
      this.$axios.get(`/posts/1`).then((res) => {
        let str = res.data.post.post_content;
        str = str.replace(/[\r\n]/g, "");
        let pRe = new RegExp(/<p>{.*}<\/p>/gi); // 匹配包含对象的<p>标签
        str = str.match(pRe);
        if (str) {
          this.countPageContent = JSON.parse(str[0].slice(3, -4));
        } else {
          this.countPageContent = JSON.parse(res.data.post.post_content);
        }
        this.countPageContent[name]
          ? (this.countPageContent[name].count += 1)
          : (this.countPageContent[name] = {
              name: data.post_title,
              count: 1,
              pageId: data.id,
              trem_name: data.term_name,
              termId: data.term_id,
            });
        // console.log(this.countPageContent)

        // 修改文章
        // this.countPageContent={}
        this.$axios
          .put(`/posts/1`, {
            post_content: `<p>${JSON.stringify(this.countPageContent)}</p>`,
          })
          .then((res) => {
            // console.log(res.data);
          });
      });
    },
    // 获取 termID
    getTermId() {
      this.$axios
        .get(
          `/term?names=${
            this.searchTermStr +
            "Get started,Pricing %26amp; Plans,Miscellaneous,General"
          }`
        )
        .then((res) => {
          // console.log(res)
          res.data.terms.forEach((item) => {
            this.searchIdStr += item.term_id + ",";
          });
          this.searchIdStr = this.searchIdStr.slice(0, -1);
        });
    },
    // 获取 热门文章
    getHotArticle() {
      // 接口获取计数文章
      this.$axios.get(`/posts/1`).then((res) => {
        let str = res.data.post.post_content;
        str = str.replace(/[\r\n]/g, "");
        let pRe = new RegExp(/<p>{.*}<\/p>/gi); // 匹配包含对象的<p>标签
        str = str.match(pRe);
        let dataObj = JSON.parse(str[0].slice(3, -4));
        // console.log(dataObj)
        let dataArr = [];
        dataArr.push(
          Object.keys(dataObj).map((key) => {
            return dataObj[key];
          })
        );
        // console.log(dataArr)
        this.hotArticle = dataArr[0].sort((a, b) => {
          return b.count - a.count;
        });
        this.mostPopular_data = this.hotArticle.slice(0, 10);
        // console.log(this.hotArticle)
        // console.log(this.popular_search)
      });
    },
    // 搜索
    searchArticle(sText, type) {
      if (type === 1) {
        // console.log(sText)
        // 过滤
        this.input_data = this.input_data.filter((item) => {
          if (this.input_data.length > 0) {
            this.searchShow(1);
            return item.post_title.indexOf(sText) !== -1;
          } else {
          }
        });

        clearTimeout(this.searchBetweenTimer);
        // 查询
        this.searchBetweenTimer = setTimeout(() => {
          this.$axios
            .get(
              `/posts?term_ids=${this.searchIdStr}&name=${sText}&size=100&need_term_name=true`
            )
            .then((res) => {
              this.input_data = res.data.posts;
              if (this.input_data.length > 0) {
                this.searchShow(1);
              }
            });
        }, 200);
      } else if (type === 2) {
        if (sText !== "") {
          this.changeRoute(sText, 2);
        }
      } else if (type === 3) {
        this.$axios
          .get(
            `/posts?term_ids=${this.searchIdStr}&name=${sText}&size=100&need_term_name=true`
          )
          .then((res) => {
            // console.log(sText)
            res.data.posts.forEach((item) => {
              item.post_content = item.post_content
                .replace(/<\/?[^>]*>/g, "")
                .replace(/[ | ]*\n/g, "\n")
                .replace(/&nbsp;/g, " ")
                .replace(/\n/gi, "");
              // item.post_content = this.heightLight(item.post_content,sText)
              item.post_title = this.heightLight(item.post_title,sText)
            });
            // console.log(res.data.posts);
            this.article_data = res.data.posts;
            this.searchContent = this.searchText;
            // this.$forceUpdate();
            // console.log(123123)
          });
      }
    },
    listclick(){
      this.showCategory=false
    },
    // 根据termName 获取当前类目所有文章
    getArticleByName(index,tName,count, data) {
      // if(this.thirdNode!= count && !this.category_data[index].data[count].post){
      // count == -1;
      if(this.category_data[index].data[count].post == undefined){
      this.thirdNode = count
      this.forthNode = 0
      this.articleNumber = 1
        this.$axios.get(`/term?names=${tName}`).then((res) => {
          // console.log(res);
          let tId = res.data.terms[0].term_id;
          this.$axios.get(`/posts?term_ids=${tId}&need_term_name=true`).then((res) => {
            // console.log(res.data);
            var post = res.data.posts.sort(function(a,b){
              return new Date(a.post_date).getTime() - new Date(b.post_date).getTime()
            })
            this.category_data[index].data[count].post = post
            this.articleId=[1,index,count,0]
            this.articleNumber = post.length
            if (this.$route.path !== "/help/detail?p=" + data.post[0].id) {
              this.getAndSaveCount(data.post[0].post_title, data.post[0]);
              this.$router.push({path: "/help/detail?p=" + data.post[0].id}).catch((err) => {});
            }
            
            // setTimeout(()=>{
            //   this.articleName = this.category_data[index].data[count].post[0].post_title
            //   this.articleContent = this.category_data[index].data[count].post[0].post_content.replace(/&nbsp;/g, " ")
            //   this.articleNumber = this.category_data[index].data[count].post.length
            // },1)
            // console.log(this.articleId);
          })
        })
      }
      else if(this.thirdNode === count && this.category_data[index].data[count].post.length != 1){
        this.thirdNode = -1;
        this.forthNode = 0;
        this.articleNumber = this.category_data[index].data[count].post.length
        if (this.$route.path !== "/help/detail?p=" + data.post[0].id) {
          this.$router.push({path: "/help/detail?p=" + data.post[0].id}).catch((err) => {});
        }
      }
      else{
        this.thirdNode = count
        this.forthNode = 0
        this.articleId=[1,index,count,0] 
        this.articleNumber = data.post.length
        if (this.$route.path !== "/help/detail?p=" + data.post[0].id) {
          this.getAndSaveCount(data.post[0].post_title, data.post[0]);
          this.$router.push({path: "/help/detail?p=" + data.post[0].id}).catch((err) => {});
        }

        // this.articleName = this.category_data[index].data[count].post[0].post_title
        // this.articleContent = this.category_data[index].data[count].post[0].post_content.replace(/&nbsp;/g, " ")
        // this.articleNumber = this.category_data[index].data[count].post.length
        // console.log(this.articleId)
      }
      if(tName!="CTA pop-ups" && tName!="Announcement bar"){
        this.showCategory=false
      }
    },
    getDirectionsArticleByName(index,tName, data) {
      if(this.directions_data[index].data == ''){
         console.log(123)
        this.secondNode = index
        this.thirdNode = 0
        this.articleNumber = 1
        if(tName == "Pricing & Plans") {tName = "Pricing %26amp; Plans"}
        this.$axios.get(`/term?names=${tName}`).then((res) => {
          let tId = res.data.terms[0].term_id;
          this.$axios.get(`/posts?term_ids=${tId}&need_term_name=true`).then((res) => {
            this.directions_data[index].data = res.data.posts.sort(function(a,b){
              return new Date(a.post_date).getTime() - new Date(b.post_date).getTime()
            })
            this.articleId=[0,index,0,0]
            if (this.$route.path !== "/help/detail?p=" + data.data[0].id) {
              this.getAndSaveCount(data.data[0].post_title, data.data[0]);
              this.$router.push({path: "/help/detail?p=" + data.data[0].id}).catch((err) => {});
            }

            // this.articleName = this.directions_data[index].data[0].post_title
            // this.articleContent=this.directions_data[index].data[0].post_content.replace(/&nbsp;/g, " ")
            this.articleNumber = this.directions_data[index].data.length
            if(index==0||index==1){
              this.showCategory=false
            }   
            // console.log(this.articleId);
          })
        })  
      }
      else if(this.secondNode == index && this.directions_data[index].data.length != 1){
        console.log(666)
        this.secondNode = -1;
        this.thirdNode = 0
        if (this.$route.path !== "/help/detail?p=" + data.data[0].id) {
          this.$router.push({path: "/help/detail?p=" + data.post[0].id}).catch((err) => {});
        }
        if(index==0||index==1){
          this.showCategory=false
        }   
      }
      else{
        console.log(777)
        this.secondNode = index
        this.thirdNode = 0
        this.articleId=[0,index,0,0]
        if (this.$route.path !== "/help/detail?p=" + data.data[0].id) {
          this.getAndSaveCount(data.data[0].post_title, data.data[0]);
          this.$router.push({path: "/help/detail?p=" + data.data[0].id}).catch((err) => {});
        }

        // this.articleName = this.directions_data[index].data[0].post_title
        // this.articleContent=this.directions_data[index].data[0].post_content.replace(/&nbsp;/g, " ")
        this.articleNumber = this.directions_data[index].data.length
        if(index==0||index==1){
          this.showCategory=false
        }   
        // console.log(this.articleId);
      }
    },
    changeArticleByName(index,count,data){
      this.getAndSaveCount(data.post_title, data);
      this.$router.push({path: "/help/detail?p=" + data.id}).catch((err) => {});
      if(this.showCategory){
        this.showCategory=false
      }
      // this.thirdNode = count
      // this.articleId=[0,index,count,0]
      // this.articleName = this.directions_data[index].data[count].post_title
      // this.articleContent=this.directions_data[index].data[count].post_content.replace(/&nbsp;/g, " ")
      // console.log(this.articleId);
    },
    changeArticle(index,count,number,data){
      // console.log("333:",data)
      this.getAndSaveCount(data.post_title, data);
      this.$router.push({path: "/help/detail?p=" + data.id}).catch((err) => {});
      this.showCategory=false
      // this.forthNode = number
      // this.articleId[3] = number
      // this.articleName = this.category_data[index].data[count].post[number].post_title
      // this.articleContent = this.category_data[index].data[count].post[number].post_content.replace(/&nbsp;/g, " ")
      // console.log(this.articleId);
    },
    // 根据文章id获取文章内容
    getPage() {
      this.$axios.get(`/posts/${this.pageId}`).then((res) => {
        if (res.data.success && res.data.post) {
          this.articleName = res.data.post.post_title;
          this.articleContent = res.data.post.post_content
            .replace(/&nbsp;/g, " ");
            // .replace(/ /g, " ");
            this.itemToNavigation(res.data.post);
        }
      });
    },
    // 导航栏反向定位
    itemToNavigation(data) {
      // console.log(data);
      // console.log(this.directions_data);
      // console.log(data.term_name);
      // console.log(this.category_data);
      if(data.term_name == 'Pricing &amp; Plans') data.term_name = 'Pricing & Plans'
      this.directions_data.forEach((secondItem,secondId)=>{
        if (secondItem.name === data.term_name) {
          this.firstNode = 0;
          this.secondNode = secondId;
          this.$axios.get(`/posts?term_ids=${data.term_id}&need_term_name=true`).then((res) => {
            this.articleNumber = res.data.posts.length
            if (res) {
              this.directions_data[secondId].data = res.data.posts.sort(function(a,b){
                return new Date(a.post_date).getTime() - new Date(b.post_date).getTime()
              });
              // console.log(this.directions_data)
              // console.log(this.directions_data[secondId])
              res.data.posts.forEach((thirdItem, thirdId)=>{
                if (thirdItem.post_title === data.post_title) {
                  this.thirdNode= thirdId;
                  this.articleId = [this.firstNode, this.secondNode, this.thirdNode, -1]
                  // console.log(this.firstNode, this.secondNode, this.thirdNode, this.forthNode)
                  // this.$forceUpdate();
                }
              });
            }
          })
        } 
      })
      this.category_data.forEach((firstItem, secondId)=>{
        firstItem["data"].forEach((secondItem, thirdId)=>{
          // console.log(secondItem['app_name']);
          // console.log(data.term_name);
          if (secondItem['app_name'] === data.term_name) {
            
            this.firstNode = 1;
            this.secondNode = secondId;
            this.thirdNode = thirdId;
            this.$axios.get(`/posts?term_ids=${data.term_id}&need_term_name=true`).then((res) => {
              if (res) {
                this.category_data[secondId].data[thirdId].post = res.data.posts.sort(function(a,b){
                  return new Date(a.post_date).getTime() - new Date(b.post_date).getTime()
                });
                this.articleNumber = res.data.posts.length
                // console.log(this.category_data);
                res.data.posts.forEach((forthItem, forthId)=>{
                  if (forthItem.post_title === data.post_title) {
                    this.forthNode= forthId;
                    this.articleId = [this.firstNode, this.secondNode, this.thirdNode, this.forthNode]
                    // console.log(this.firstNode, this.secondNode, this.thirdNode, this.forthNode)
                    // this.$forceUpdate();
                  }
                })
              }
            })
          }
        })
      })
    },
    // 切换路由
    changeRoute(val, type) {
      if (type === 1) {
        this.getAndSaveCount(val);
        this.$router
          .push({
            path: "/help/detail?p=" + val.pageId,
          })
          .catch((err) => {
            // console.log('e',err)
          });
      } else if (type === 2) {
        this.$router
          .push({
            path: "/help/detail?t=" + val,
          })
          .catch((err) => {
            // console.log('e',err)
          });
        // window.location.pathname =`/help/detail?t=${val}`
      } else if (type === 3) {
        this.$router
          .push({
            path: "/help/detail?most=" + val,
          })
          .catch((err) => {
            // console.log('e',err)
          });
      } else if (type === 4) {
        // console.log(val)
        this.getAndSaveCount(val.post_title)
        this.$router.push({
          path: '/help/detail?p=' + val.id
        }).catch(err => {
          // console.log('e',err)
        })
      }
    },

    //高亮字符串 string: 需要处理的字符串，keyword：键盘输入的内容
    heightLight(string, keyword) {
      var reg = new RegExp(keyword, "gi");
      string = string.replace(reg, function (txt) {
        return "<i>" + txt + "</i>";
      });
      return string;
    },

    firstNodeClick(index){
      if(this.firstNode === index){
        this.firstNode = -1;
      }else{
        this.firstNode = index;
        this.secondNode = -1;
      }
    }, 
    secondNodeClick(index){
      if(this.secondNode === index){
        this.secondNode = -1;
      }else{
        this.secondNode = index;
        this.thirdNode = -1;
      }
    }, 
    thirdNodeClick(count){
      if(this.thirdNode === count){
        this.thirdNode = -1;
      }else{
        this.thirdNode = count;
      }
    },
    // 判断路由跳转是否合理
    routerChange() {
      // this.secondNode = -1;
      // this.firstNode = -1;
      // this.thirdNode = -1;
      // this.forthNode = -1;
      // this.articleId = [-1, -1, -1, -1];
      if (this.$route.query.p) {
        this.pageId = this.$route.query.p;
        this.popularFlag = false;
        this.categoryFlag = true;
        this.getPage();
      } else if (this.$route.query.t) {
        this.searchText = this.$route.query.t;
        this.popularFlag = false;
        this.categoryFlag = false;
        this.searchArticle(this.searchText, 3);
      } else if (this.$route.query.most) {
        this.popularFlag = true;
        this.categoryFlag = true;
        this.getHotArticle();
      }
    }
  },
  created() {
    if(document.body.offsetWidth>767){
      this.ispc=true
    }else{
      this.ispc=false
      window.addEventListener("click", this.listclick);
    }
    this.getData();
  },
  watch: {
    $route(to, from) {
      //监听路由是否变化
      this.routerChange();
    },
  },
};
</script>

<style>
.helpCenter_search {
  background: #f9fbff;
}
.helpCenter_search_box {
  width: 1200px;
  margin: auto;
  display: flex;
}
.helpCenter_search_left {
  padding-top: 60px;
  /* width: 354px; */
  display: inline-block;
}
.helpCenter_search_left_top_input {
  width: 354px;
  height: 50px;
  background: #ffffff;
  box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.08);
  border-radius: 4px;
  font-size: 16px;
  font-family: Helvetica-Regular, Helvetica;
  font-weight: 400;
  line-height: 19px;
  text-shadow: 0px 2px 8px rgba(0, 0, 0, 0.08);
  /* text-transform: capitalize; */
  padding-left: 15px;
  padding-right: 32px;
}
.helpCenter_search_left_top_input:focus {
  border: 2px solid #01C4C7;
  border-radius: 4px 0 0 4px;
}
.helpCenter_search_left_top_input::placeholder {
  color: rgba(0, 0, 0, 0.25);
}
.helpCenter_search_left_top {
  position: relative;
}
.helpCenter_search_left_top img {
  position: absolute;
  right: 14px;
  top: 18px;
  cursor: pointer;
}

.search_data {
  width: 354px;
  max-height: 400px;
  background: #ffffff;
  box-shadow: 0px 6px 16px 0px rgba(0, 0, 0, 0.08),
    0px 3px 6px -4px rgba(0, 0, 0, 0.12);
  position: absolute;
  left: 0px;
  top: 50px;
  overflow-y: auto;
  padding: 4px 0;
}
.search_data_list {
  /* height: 40px; */
  background: #ffffff;
  font-size: 14px;
  font-family: Helvetica-Regular, Helvetica;
  font-weight: 400;
  color: #8c8c8c;
  /* line-height: 40px; */
  cursor: pointer;
  padding: 16px 12px;
}
.search_data_list:hover,
.search_data_list:focus {
  background: #01c4c70c;
  color: #00b9bc;
}

.helpCenter_search_left_category{
  margin-top: 48px;
  width: 360px;
}
.helpCenter_search_left_category_title{
  font-size: 20px;
  font-family: Helvetica-Regular, Helvetica;
  font-weight: 400;
  color: #222536;
  line-height: 24px;
}
.helpCenter_search_left_category_list{
  margin-top: 40px;
  font-size: 16px;
  font-family: Helvetica-Regular, Helvetica;
  font-weight: 400;
  color: #222536;
  /* line-height: 19px; */
}
.helpCenter_search_left_category_list img{
  margin-right: 12px;
}
.helpCenter_search_left_category_ul{
  margin-bottom: 6px;
  /* cursor: pointer; */
}
.helpCenter_search_left_category_ul_div{
  /* width: 324px; */
  height: 36px;
  line-height: 36px;
}
.helpCenter_search_left_category_ul_div:hover{
  background: rgba(1, 196, 199, 0.05);
  border-radius: 5px;
}
.helpCenter_search_left_category_ul div{
  cursor: pointer;
}
.helpCenter_search_left_category_first{
  margin-left: 14px;
}
.helpCenter_search_left_category_first_hide{
  display: none;
}
.helpCenter_search_left_category_li{
  /* padding: 9px 0; */
  margin-top: 10px;
}
.helpCenter_search_left_category_li_div{
  /* width: 324px; */
  height: 36px;
  line-height: 36px;
}
.helpCenter_search_left_category_li_div:hover{
  /* height: 36px; */
  background: rgba(1, 196, 199, 0.05);
  border-radius: 5px;
}
.helpCenter_search_left_category_li_second:first-child {
  margin-top: 9px;
}
.helpCenter_search_left_category_choose{
  /* width: 310px; */
  height: 36px;
  line-height: 36px;
  font-size: 16px;
  font-family: Helvetica-Regular, Helvetica;
  font-weight: 400;
  color: #01C4C7;
  background-color: rgba(1, 196, 199, 0.05);
  border-radius: 5px;
  margin: 5px 0;
}
/* .helpCenter_search_left_category_choose img{
  content: url('../assets/help_bottom_green.svg');
} */
.helpCenter_search_left_category_nochoose{
  /* width: 310px; */
  height: 36px;
  line-height: 36px;
  margin: 5px 0;
}
.helpCenter_search_left_category_nochoose:hover{
  /* height: 30px; */
  background-color: rgba(1, 196, 199, 0.05);
  border-radius: 5px;
}
.helpCenter_search_left_category_second{
  margin-left: 14px;
}
.helpCenter_search_left_category_second_hide{
  display: none;
}

.helpCenter_search_left_category_third{
  margin-left: 14px;
}
.helpCenter_search_left_category_third_hide{
  display: none;
}
.helpCenter_search_left_category_forth{
  /* width: 296px; */
  height: 35px;
  line-height: 35px;
  padding-left: 28px;
  margin-top: 9px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.helpCenter_search_left_category_forth:hover{
  background-color: rgba(1, 196, 199, 0.05);
  border-radius: 5px;
}
.helpCenter_search_left_category_forth_choose{
  font-size: 16px;
  font-family: Helvetica-Regular, Helvetica;
  font-weight: 400;
  color: #01C4C7;
  background-color: rgba(1, 196, 199, 0.05);
  border-radius: 5px;
}

.helpCenter_search_right {
  padding-top: 30px;
  flex: 1;
  /* margin-left: 25px; */
}
.helpCenter_search_right_top {
  font-size: 14px;
  font-family: Helvetica-Regular, Helvetica;
  font-weight: 400;
  color: #222536;
  line-height: 22px;
  display: flex;
  margin-top: 30px;
}
.helpCenter_search_right_top_text {
  padding-right: 8px;
}
.helpCenter_search_right_top img {
  padding-right: 8px;
}
.helpCenter_search_right_article {
  width: 800px;
  min-height: 600px;
  background: #ffffff;
  box-shadow: 0px 5px 4px 0px rgba(167, 167, 167, 0.08);
  border-radius: 10px;
  margin: 30px auto 100px;
  /* margin-top: 30px;
  margin-bottom: 100px; */
}
.helpCenter_search_right_article_top {
  display: flex;
  justify-content: space-between;
  padding-top: 45px;
  padding-left: 30px;
}
.helpCenter_search_right_article_title {
  font-size: 32px;
  font-family: Helvetica-Medium, Helvetica;
  font-weight: 600;
  color: #222536;
  line-height: 40px;
}
.helpCenter_search_right_article_title span {
  font-weight: bold;
  color: #01c4c7;
}
.helpCenter_search_right_article_count {
  font-size: 20px;
  font-family: Helvetica-Bold, Helvetica;
  font-weight: normal;
  color: #8c8c8c;
  line-height: 40px;
  padding-right: 30px;
}
.helpCenter_search_right_article_count span {
  font-size: 22px;
  font-weight: bold;
  color: #222536;
}
.helpCenter_search_right_article_notfound{
  font-size: 20px;
  font-family: Helvetica-Regular, Helvetica;
  font-weight: 400;
  color: #8590ac;
  line-height: 27px;
  padding-top: 20px;
}
.helpCenter_search_right_article_content {
  margin: 20px 30px 60px;
  padding: 0;
}
.helpCenter_search_right_article_content_box {
  border-bottom: 1px solid #cbcbcb;
  padding: 25px 0;
}
.helpCenter_search_right_article_content_box:last-child {
  border-bottom: none;
}
.helpCenter_popular_right_article_content_box {
  border-bottom: 1px solid #cbcbcb;
  padding: 26px 0;
}
.helpCenter_popular_right_article_content_box:last-child {
  border-bottom: none;
}
.helpCenter_search_right_article_content_title {
  font-size: 24px;
  font-family: Helvetica-Regular, Helvetica;
  font-weight: 400;
  color: #222536;
  line-height: 28px;
  margin-bottom: 15px;
  cursor: pointer;
}
.helpCenter_search_right_article_content_title i{
  font-family: Helvetica-Bold, Helvetica;
  font-weight: bold;
  font-style: normal;
}
.helpCenter_search_right_article_content_content {
  font-size: 20px;
  font-family: Helvetica-Regular, Helvetica;
  font-weight: 400;
  color: #8590ac;
  line-height: 27px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  cursor: pointer;
}
.helpCenter_search_right_article_content_content_most{
  font-size: 20px;
  font-family: Helvetica-Regular, Helvetica;
  font-weight: 400;
  color: #8590ac;
  line-height: 27px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  cursor: pointer;
}
.helpCenter_search_right_article_content_content_most:hover{
  color: #01C4C7;
}
@media (max-width:767px){
  .cover{
    width: 100%;
    background: rgba(0,0,0,.5);
    z-index: 997;
    position: fixed;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
  }
  .helpCenter_search {
    padding-top: 1.06rem;
    background: #ffffff;
  }
  .helpCenter_search_box {
    display: block;
    width: 100%;
    padding: .45rem .48rem .75rem;
  }
  .helpCenter_search_left_category{
    width: 100%;
    position: fixed;
    top: 1.05rem;
    z-index:998;
    margin-top:0;
    background: #FFFFFF;
    max-height: 100%;
    overflow-y: auto;
    box-shadow: rgb(31 41 64 / 8%) 0px 8px 8px 0px
  }
  .helpCenter_search_left_category_title{
    font-weight: 700;
    font-size: .36rem;
    color: rgba(34,37,54,.85);
    height: 0.88rem;
    padding: 0.2rem 0.48rem 0.2rem 0.48rem;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .helpCenter_search_left_category_title img{
    width: .46rem;
    height: .46rem;
  }
  .helpCenter_search_left_category_list{
    width: 100%;
    font-size: .24rem;
    color: #222536;
    font-weight: 400;
    cursor: pointer;
    margin-top: 0;
  }
  .helpCenter_search_left_category_list img{
    margin-right: .12rem;
  }
  .helpCenter_search_left_category_ul{
    height: 0.64rem;
    width: 100%;
    font-size: .24rem;
    color: #222536;
    font-weight: 400;
    padding: 0.22rem 0 0.22rem 0.48rem;
    cursor: pointer;
    display: flex;
    align-items: center;
    margin-top: 0;
    margin-bottom:0
  }
  .helpCenter_search_left_category_ul_div{
    height: auto;
    line-height: initial;
  }
  .helpCenter_search_left_category_ul_div:hover{
    background: #FFFFFF;
    border-radius: 0;
  }
  .helpCenter_search_left_category_first{
    margin-left: .4rem;
  }
  .helpCenter_search_left_category_li_div{
    height: auto;
    line-height: initial;
    display: flex;
    align-items: center;
  }
  .helpCenter_search_left_category_li_div:hover{
    /* height: 36px; */
    background: #FFFFFF;
    border-radius: 0;
  }
  .helpCenter_search_left_category_li_second:first-child {
    margin-top: 0;
  }
   .helpCenter_search_left_category_li_second{
    height: auto;
    width: 100%;
    font-size: .24rem;
    color: #222536;
    font-weight: 400;
    padding: 0.22rem 0 0 0.28rem;
    cursor: pointer;
    margin-top: 0;
   }

  .helpCenter_search_left_category_choose{
    height: .36rem;
    line-height: .36rem;
    font-size: .24rem;
    font-family: Helvetica-Regular, Helvetica;
    font-weight: 400;
    color: #222536;
    background-color: initial;
    border-radius: 0;
    margin: 0;
  }
  .helpCenter_search_left_category_nochoose{
    height: auto;
    line-height: initial;
    margin: 0;
  }
  .helpCenter_search_left_category_nochoose:hover{
     background: #FFFFFF;
    border-radius: 0;
  }
  .helpCenter_search_left_category_second{
    margin-left: .14rem;
  }
  .helpCenter_search_left_category_third{
    margin-left: .14rem;
  }
  .helpCenter_search_left_category_forth{
    height: auto;
    line-height: initial;
    margin-top: .12rem;
    height: auto;
    width: 100%;
    font-weight: 400;
    padding: 0.1rem  0 .1rem .28rem;
  }
  .helpCenter_search_left_category_forth:hover{
     background: rgba(1, 196, 199, 0.05);
    border-radius: 0;
  }
  .helpCenter_search_left_category_forth_choose{
    font-size: .24rem;
    color: #01C4C7;
    background-color: rgba(1, 196, 199, 0.05);
    border-radius: 0;
  }
  .helpCenter_search_right {
    padding-top: 0;
    flex: 1;
  }
  .helpCenter_search_left_category_li{
    height: auto;
    width: 100%;
    font-size: .24rem;
    color: #222536;
    font-weight: 400;
    padding: 0.22rem 0 0.22rem 0.28rem;
    cursor: pointer;
    margin-top: 0;
  }
  .helpCenter_display{
    display: flex;
    align-items: center;
  }
  .helpCenter_search_right_top {
    font-size: 14px;
    font-family: Helvetica-Regular, Helvetica;
    font-weight: 400;
    color: #222536;
    line-height: 22px;
    display: flex;
    margin-top: 30px;
  }
  .helpCenter_search_right_top_text {
    padding-right: 8px;
  }
  .helpCenter_search_right_top img {
    padding-right: 8px;
  }
  .helpCenter_search_right_article {
    width: 100%;
    min-height: 6rem;
    box-shadow: none;
    border-radius: 0;
    margin: 0 auto;
  }
  .helpCenter_search_right_article_top {
    padding-top: 0;
    padding-left: 0;
  }
  .helpCenter_search_right_article_title {
    font-size: .3rem;
    font-weight: 400;
    line-height: .4rem;
  }
  .helpCenter_search_right_article_count {
    font-size: .2rem;
    font-weight: 400;
    color: #8590AC;
    line-height: .4rem;
    padding-right: 0;
  }
  .helpCenter_search_right_article_count span {
    font-size: .22rem;
  }
  .helpCenter_search_right_article_notfound{
     font-size: .2rem;
    line-height: initial;
    padding-top: 0;
  }
  .helpCenter_search_right_article_content {
    margin: .21rem 0 0;
    padding: 0;
  }
  .helpCenter_search_right_article_content_box {
    border-bottom: 1px solid #cbcbcb;
    padding: .25rem 0;
  }
  .helpCenter_popular_right_article_content_box {
    border-bottom: 1px solid #cbcbcb;
    padding: .25rem 0;
  }
  .helpCenter_popular_right_article_content_box:last-child {
    border-bottom: none;
  }
  .helpCenter_search_right_article_content_title {
    font-size: .24rem;
    line-height: .29rem;
    margin-bottom: .15rem;
  }
  .helpCenter_search_right_article_content_content {
    font-size: .2rem;
    line-height: .27rem;
  }
  .helpCenter_search_right_article_content_content_most{
    font-size: .2rem;
    line-height: .27rem;
  }
  .helpCenter_display2{
    color:#01C4C7
  }
}
</style>

<style>
.helpCenter_search_right_article_html {
  width: 807px;
  padding: 45px 30px;
}
.helpCenter_search_right_article_html_title {
  font-size: 32px;
  font-family: Helvetica-Medium, Helvetica;
  font-weight: 600;
  color: #222536;
  line-height: 40px;
  text-transform: none;
}
.helpCenter_search_right_article_html_content {
  margin-top: 34px;
}
.helpCenter_search_right_article_html_content h3 {
  font-size: 20px;
  margin-bottom: 20px;
  line-height: 24px;
  font-weight: 400;
  text-transform: none;
}
.helpCenter_search_right_article_html_content .wp-block-image {
  margin-bottom: 25px;
}
.helpCenter_search_right_article_html_content .size-large {
  height: auto;
  max-width: 100%;
}
figure {
  margin: 0 auto;
  clear: both;
  display: table;
}
.helpCenter_search_right_article_html_content img {
  max-width: 100%;
  height: auto;
}
figure figcaption {
  margin: 8px 0 17px;
  display: table-caption;
  caption-side: bottom;
}
.helpCenter_search_right_article_html_content p {
  margin-bottom: 25px;
  font-weight: 400;
  text-transform: none;
  font-size: 17px;
  line-height: 1.5;
  font-family: "Open Sans", sans-serif;
  color: #3a3a3a;
}
.helpCenter_search_right_article_html_content p:last-child {
  margin-bottom: 0;
}
.helpCenter_search_right_article_html_content a,
.helpCenter_search_right_article_html_content a:visited {
  color: #1e73be;
}
.helpCenter_search_right_article_html_content a:hover,
.helpCenter_search_right_article_html_content a:active {
  color: #000000;
}
.helpCenter_search_right_article_html_content ul,
.helpCenter_search_right_article_html_content ol {
  list-style: disc;
}
.helpCenter_search_right_article_html_content > ul {
  margin: 0 0 25px 51px;
}
.helpCenter_search_right_article_html_content ul li {
  font-weight: 400;
  text-transform: none;
  font-size: 17px;
  line-height: 1.5;
  font-family: "Open Sans", sans-serif;
  color: #3a3a3a;
}
.helpCenter_search_right_article_html_content ul li > ul {
  margin-left: 25px;
}
.helpCenter_search_right_article_html_content ul li::marker {
  unicode-bidi: isolate;
  font-variant-numeric: tabular-nums;
  text-transform: none;
}
.helpCenter_search_right_article_html_content .salesdish_video {
  display: flex;
  justify-content: center;
}
.helpCenter_search_right_article_html_content .salesdish_video iframe {
  width: 740px;
  height: 416px;
}
.wp-block-buttons {
  margin: 34px 0;
}
.wp-block-buttons a {
  color: #fc5322;
  font-size: 18px;
}
.wp-block-buttons a:hover,
.wp-block-buttons a:focus,
.wp-block-buttons a:active {
  color: #fc5322;
}
.aligncenter {
  text-align: center;
}
@media (max-width:767px){
  .helpCenter_search_right_article_html {
    width: 100%;
    padding-top:.63rem;
  }
  .helpCenter_search_right_article_html_title {
    font-size: .32rem;
    line-height: .4rem;
  }
  .helpCenter_search_right_article_html_content {
    margin-top: .34rem;
  }
  .helpCenter_search_right_article_html_content h3 {
    font-size: .2rem;
    margin-bottom: .2rem;
    line-height: .24rem;
  }
  .helpCenter_search_right_article_html_content .wp-block-image {
    margin-bottom: .25rem;
  }
  figure figcaption {
    margin: .08rem 0 .17rem;
  }
  .helpCenter_search_right_article_html_content p {
    margin-bottom: .25rem;
    font-size: .17rem;
  }
  .helpCenter_search_right_article_html_content > ul {
    margin: 0 0 .25rem .51rem;
  }
  .helpCenter_search_right_article_html_content ul li {
    font-size: .17rem;
  }
  .helpCenter_search_right_article_html_content ul li > ul {
    margin-left: .25rem;
  }
  .helpCenter_search_right_article_html_content .salesdish_video iframe {
    width: 100%;
    height: 4.16rem;
  }
  .wp-block-buttons {
    margin: .34rem 0;
  }
  .wp-block-buttons a {
    font-size: .18rem;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/detail.vue